import Card from './components/Card';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'card',
  pluginComponent: Card,
});
